document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.hash) return;

  let target;

  try {
    target = document.querySelector(window.location.hash);
  } catch (error) {
    return;
  }

  if (!target) return;

  const details = target.closest('details');

  if (!details) return;

  details.open = true;

  requestAnimationFrame(function () {
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
});